<template>
    <div 
      class="setor-card" 
      :class="{ 'ativo': setor.status === 'ativo', 'inativo': setor.status === 'inativo' }"
      @click="$emit('click-setor', setor)"
    >
      <!-- Header do Setor -->
      <div class="setor-header">
        <div class="setor-info">
          <h4 class="setor-nome">{{ setor.nome }}</h4>
          <p class="setor-chefe">👤 {{ setor.chefe_nome }}</p>
        </div>
        <div class="setor-status">
          <span 
            class="status-badge" 
            :class="setor.status"
          >
            {{ setor.status === 'ativo' ? '🟢 ATIVO' : '⚫ INATIVO' }}
          </span>
        </div>
      </div>
  
      <!-- Conteúdo do Setor Ativo -->
      <div v-if="setor.status === 'ativo'" class="setor-conteudo">
        <!-- Estatísticas -->
        <div class="setor-stats">
          <div class="stat-item">
            <span class="stat-label">👥 Funcionários:</span>
            <span class="stat-value">{{ setor.funcionarios_ativos }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">⏱️ Capacidade:</span>
            <span class="stat-value">{{ setor.capacidade_horas }}h</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">📊 Utilização:</span>
            <span class="stat-value" :class="getCorUtilizacao(setor.utilizacao_percentual)">
              {{ setor.utilizacao_percentual }}%
            </span>
          </div>
        </div>
  
        <!-- Barra de Progresso -->
        <div class="progresso-container">
          <div class="progresso-label">Utilização da Capacidade</div>
          <div class="progresso-barra">
            <div 
              class="progresso-fill"
              :class="getCorUtilizacao(setor.utilizacao_percentual)"
              :style="{ width: setor.utilizacao_percentual + '%' }"
            ></div>
          </div>
          <div class="progresso-texto">{{ setor.utilizacao_percentual }}%</div>
        </div>
  
        <!-- Lista de Funcionários -->
        <div v-if="setor.funcionarios && setor.funcionarios.length > 0" class="funcionarios-section">
          <div class="funcionarios-header">👥 Equipe Ativa:</div>
          <div class="funcionarios-lista">
            <span 
              v-for="funcionario in setor.funcionarios.slice(0, 3)" 
              :key="funcionario.id"
              class="funcionario-chip"
              :title="funcionario.nome"
            >
              {{ funcionario.nome.split(' ')[0] }}
            </span>
            <span 
              v-if="setor.funcionarios.length > 3"
              class="funcionario-chip mais"
              :title="`${setor.funcionarios.length - 3} funcionários a mais`"
            >
              +{{ setor.funcionarios.length - 3 }}
            </span>
          </div>
        </div>
  
        <!-- Ações -->
        <div class="setor-acoes">
          <button 
            class="btn-acao primario"
            @click.stop="$emit('ver-equipe', setor)"
          >
            👥 Ver Equipe
          </button>
          <button 
            class="btn-acao secundario"
            @click.stop="$emit('ver-detalhes', setor)"
          >
            📊 Detalhes
          </button>
        </div>
      </div>
  
      <!-- Conteúdo do Setor Inativo -->
      <div v-else class="setor-inativo">
        <div class="inativo-icon">😴</div>
        <p class="inativo-texto">Expediente não aberto hoje</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SetorCard',
    
    props: {
      setor: {
        type: Object,
        required: true
      }
    },
    
    emits: ['click-setor', 'ver-equipe', 'ver-detalhes'],
    
    methods: {
      getCorUtilizacao(percentual) {
        if (percentual >= 80) return 'danger';
        if (percentual >= 50) return 'warning';
        return 'success';
      }
    }
  }
  </script>
  
  <style scoped>
  .setor-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid transparent;
  }
  
  .setor-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  }
  
  .setor-card.ativo {
    border-color: #4caf50;
  }
  
  .setor-card.ativo:hover {
    border-color: #2e7d32;
  }
  
  .setor-card.inativo {
    background: #f9f9f9;
    border-color: #e0e0e0;
  }
  
  /* Header */
  .setor-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  
  .setor-nome {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  
  .setor-chefe {
    margin: 0;
    font-size: 12px;
    color: #666;
  }
  
  .status-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  .status-badge.ativo {
    background: #e8f5e8;
    color: #2e7d32;
  }
  
  .status-badge.inativo {
    background: #f5f5f5;
    color: #666;
  }
  
  /* Estatísticas */
  .setor-stats {
    margin-bottom: 15px;
  }
  
  .stat-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .stat-label {
    color: #666;
  }
  
  .stat-value {
    font-weight: bold;
    color: #333;
  }
  
  .stat-value.success { color: #4caf50; }
  .stat-value.warning { color: #ff9800; }
  .stat-value.danger { color: #f44336; }
  
  /* Progresso */
  .progresso-container {
    margin-bottom: 15px;
  }
  
  .progresso-label {
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
  }
  
  .progresso-barra {
    background: #e0e0e0;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }
  
  .progresso-fill {
    height: 100%;
    transition: width 0.3s ease;
  }
  
  .progresso-fill.success { background: linear-gradient(90deg, #4caf50, #8bc34a); }
  .progresso-fill.warning { background: linear-gradient(90deg, #ff9800, #ffc107); }
  .progresso-fill.danger { background: linear-gradient(90deg, #f44336, #ff5722); }
  
  .progresso-texto {
    text-align: center;
    font-size: 11px;
    color: #666;
    margin-top: 3px;
  }
  
  /* Funcionários */
  .funcionarios-section {
    margin-bottom: 15px;
  }
  
  .funcionarios-header {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
  }
  
  .funcionarios-lista {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .funcionario-chip {
    background: #e3f2fd;
    color: #1976d2;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
  }
  
  .funcionario-chip.mais {
    background: #fff3e0;
    color: #f57c00;
  }
  
  /* Ações */
  .setor-acoes {
    display: flex;
    gap: 8px;
  }
  
  .btn-acao {
    flex: 1;
    padding: 8px 12px;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .btn-acao.primario {
    background: #1976d2;
    color: white;
  }
  
  .btn-acao.primario:hover {
    background: #1565c0;
  }
  
  .btn-acao.secundario {
    background: #f5f5f5;
    color: #666;
    border: 1px solid #ddd;
  }
  
  .btn-acao.secundario:hover {
    background: #eeeeee;
  }
  
  /* Setor Inativo */
  .setor-inativo {
    text-align: center;
    padding: 20px 0;
  }
  
  .inativo-icon {
    font-size: 24px;
    margin-bottom: 8px;
  }
  
  .inativo-texto {
    color: #999;
    font-size: 14px;
    margin: 0;
  }
  
  /* Responsividade */
  @media (max-width: 768px) {
    .setor-card {
      padding: 15px;
    }
    
    .setor-acoes {
      flex-direction: column;
    }
    
    .btn-acao {
      padding: 10px;
      font-size: 13px;
    }
  }
  </style>